import { render } from "./CoopStatus.vue?vue&type=template&id=c5199294&scoped=true"
import script from "./CoopStatus.vue?vue&type=script&lang=js"
export * from "./CoopStatus.vue?vue&type=script&lang=js"

import "./CoopStatus.vue?vue&type=style&index=0&id=c5199294&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5199294"]])

export default __exports__